
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import moment, { Moment } from "moment";
import { CookieComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "dashboard",
  computed: {
    userTypeId() {
      return CookieComponent.get("userTypeId")
    },
  },
  setup() {
    const salePlan = ref({})
    const test = ref([])
    const store = useStore();
    const dataString = ref<string>("[]");
    /* store.value.dispatch(Map.FINDCLOCKFORMAP, {}); */

    const userVerify = ref<any>();
    const newsCount = ref<any>();
    const moneyRequest = ref<any>();
    const display = ref<boolean>();
    const display1 = ref<boolean>();
    const modalInfoVisible = ref<boolean>(false);
    const pageWidth = ref(window.innerWidth);

    const updateWidth = () => {
      pageWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener('resize', updateWidth);
      setCurrentPageTitle("Dashboard");
    });
    // Remove event listener when the component is unmounted
    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateWidth);
    });

    return {
      pageWidth,
      modalInfoVisible,
      salePlan,
      test,
      store,
      dataString,
      userVerify,
      newsCount,
      moneyRequest,
      display,
      display1,
    };
  },
  methods: {
    handleSelectCard(val) {
      this.salePlan = val
    },
    getDayss(i = 0) {
      let startOfWeek = null as Moment | null;
      let endOfWeek = null as Moment | null;
      if (i == 0) {
        startOfWeek = moment().startOf("isoWeek");
        endOfWeek = moment().endOf("isoWeek");
      } else {
        startOfWeek = moment().startOf("isoWeek").add(-1, "weeks");
        endOfWeek = moment().endOf("isoWeek").add(-1, "weeks");
      }
      
      let days = [] as string[];
      let day = startOfWeek;

      while (day <= endOfWeek) {
        days.push(moment(day.toDate()).format("DD-MMM-yyyy"));
        day = day.clone().add(1, "d");
      }
      return days;
    },
  },
});
